module.exports = __webpack_public_path__ + "img/Dusk-text.70407629.jpg";